require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// F:/Solutions/7572bo/master/~/core-js/fn/object/assign.js
// module id = 85
// module chunks = 1